import { useTenant } from '@rewardops/auth/src/client/use-tenant'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@rewardops/ui'
import type { FaqList, Markdown } from '@rewardops/utils'

import { formatTitleToId } from '~/utils/id-format-utils'
import { RenderMarkdown } from '../markdown/render-markdown'

type Props = {
  content?: FaqList
}

const AccordionElement = ({ faqItem }: { faqItem: Markdown }) => {
  const tenant = useTenant()
  return (
    <AccordionItem value={faqItem.title} className={`py-5 text-lg`}>
      <AccordionTrigger
        id={formatTitleToId(faqItem.title)}
        className={`text-left font-semibold ${
          tenant?.theme === 'birch' ? 'hover:text-blue-500' : ''
        }`}
      >
        {faqItem.title}
      </AccordionTrigger>
      <AccordionContent className="[&_a:hover]:underline [&_a]:text-tenant-primary-color">
        <RenderMarkdown content={faqItem?.body} />
      </AccordionContent>
    </AccordionItem>
  )
}

function AccordionList(props: Props) {
  const { content } = props

  if (!content) {
    return <>Loading</>
  }

  const openAccordionNames = content?.faqItems
    ?.filter((item) => item?.isAccordionOpenByDefault)
    ?.map((item) => item?.title)

  return (
    <div className="col-span-2">
      <div className="text-center text-[45px] font-semibold">
        {content?.title}
      </div>
      {content?.subtitle && (
        <div className="py-5 text-center">{content?.subtitle}</div>
      )}
      <div className="py-20">
        <Accordion
          type="multiple"
          className="w-full"
          defaultValue={openAccordionNames ?? []}
        >
          {content?.faqList?.map((faqItemsWrapper, wrapperInd) => (
            <div key={faqItemsWrapper.title}>
              <div className="py-5 text-left text-[22px] font-semibold">
                {faqItemsWrapper.title}
              </div>
              {faqItemsWrapper?.subtitle && (
                <div>{faqItemsWrapper?.subtitle}</div>
              )}
              {faqItemsWrapper?.faqItems?.map((faqItem) => (
                <AccordionElement key={faqItem.title} faqItem={faqItem} />
              ))}
              {content?.faqList &&
                wrapperInd !== content?.faqList?.length - 1 && (
                  <>
                    <br />
                    <br />
                  </>
                )}
            </div>
          ))}
          {content?.faqItems && (
            <>
              <br />
              <br />
            </>
          )}
          {content?.faqItems?.map((faqItem) => (
            <AccordionElement key={faqItem.title} faqItem={faqItem} />
          ))}
        </Accordion>
      </div>
    </div>
  )
}

export default AccordionList
